/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { cssMap, cx, jsx } from '@atlaskit/css';
import { Stack } from '@atlaskit/primitives/compiled';

import { expValEquals } from '@confluence/feature-experiments';

import { CtaNotifyMessageFooter, type CtaNotifyMessageFooterProps } from './CtaNotifyMessageFooter.tsx';
import { DistributionFooter, type DistributionFooterProps } from './DistributionFooter.tsx';

export type FooterProps = {
	ctaNotifyMessageFooter?: CtaNotifyMessageFooterProps;
	distributionFooter?: DistributionFooterProps;
};

const styles = cssMap({
	footer: {
		marginTop: 'auto',
	},
});

export const Footer = ({ ctaNotifyMessageFooter, distributionFooter }: FooterProps) => (
	<Stack grow="hug" xcss={cx(styles.footer)}>
		{ctaNotifyMessageFooter &&
			!expValEquals('persistence_specific_access_gate', 'cohort', 'experiment') && (
				<CtaNotifyMessageFooter {...ctaNotifyMessageFooter} />
			)}
		{distributionFooter && <DistributionFooter {...distributionFooter} />}
	</Stack>
);
